import { Route, Routes } from "react-router-dom";
import { HistoryPage } from "./pages/HistoryPage";
import { LegalPage } from "./pages/LegalPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ProposalsPage } from "./pages/ProposalsPage";
import { RecoveryPage } from "./pages/RecoveryPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<ProposalsPage />} />
      <Route path="/history" element={<HistoryPage />} />
      <Route path="/recovery" element={<RecoveryPage />} />
      <Route path="/legal/:slug" element={<LegalPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
